import { isHTMLElement } from './typeguards.js';

/**
 * Fixes cssText to be compatible with the CSSOM API.
 * @see https://drafts.csswg.org/cssom/#serialize-an-identifier
 *
 * @param input the cssText to fix
 * @returns a modified cssText
 */
const fixCssText = (input: string): string => input
    // id selectors starting with a number have to be escaped
    .replace(/#([0-9][\w\-\_\:\\]*)/g, (_, id) => '#' + CSS.escape(id));

/**
 * Adds a style element with the given cssText to the given node.
 *
 * @param cssText the cssText to add
 * @param node the node to add a style element to
 * @returns the created style element
 */
export const addCssToElement = (cssText: string, node: HTMLElement): HTMLStyleElement => {
    const targetNode = isHTMLElement(node) ? node : document.head;
    const cssNode = document.createElement('style');
    cssNode.textContent = fixCssText(cssText);
    targetNode.appendChild(cssNode);
    return cssNode;
};
